import { ReactNode, createContext, useContext } from "react";
import { useFilterWaiver } from "./filter-waiver.hook";

const FilterWaiverContext = createContext(
  {} as ReturnType<typeof useFilterWaiver>
);
export function useFilterWaiverContext() {
  return useContext(FilterWaiverContext);
}

interface FilterWaiverProviderProps {
  children: ReactNode;
}
export function FilterWaiverProvider({
  children,
}: FilterWaiverProviderProps) {
  return (
    <FilterWaiverContext.Provider value={useFilterWaiver()}>
      {children}
    </FilterWaiverContext.Provider>
  );
}